export const name = 'nativeMobileWixCodeSdk' as const
export const navigationNamespace = 'navigate-mobile' as const
